import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useGetFeaturedProductQuery } from "../../products/productSlice";
import FeaturedProduct from "./featured-product/FeaturedProduct";
import QuiekViewModal from "../../../pages/QueikViewModal/QuiekViewModal";
import { featuredDB } from "../../../rki-data/category";
import axios from "axios";
import { base_url } from "../../../server";
import { useTranslation } from "react-i18next";

import product1 from "../../../assets/img/serviceList/product-1.png";
import product2 from "../../../assets/img/serviceList/product-2.png";
import product3 from "../../../assets/img/serviceList/product-3.png";
import product4 from "../../../assets/img/serviceList/product-4.png";
import product5 from "../../../assets/img/serviceList/5.webp";
import product6 from "../../../assets/img/serviceList/6.webp";
import product7 from "../../../assets/img/serviceList/7.webp";
import product8 from "../../../assets/img/serviceList/8.webp";
import product9 from "../../../assets/img/serviceList/9.webp";
import product10 from "../../../assets/img/serviceList/10.webp";
import product11 from "../../../assets/img/serviceList/11.webp";
import product12 from "../../../assets/img/serviceList/12.webp";

import { AiFillStar } from "react-icons/ai";
import { BsArrowRight } from "react-icons/bs";
const featuredItems = [
  {
    id: "1",
    imgUrls: product1,
    title: "Ground Support",
  },
  {
    id: "2",
    imgUrls: product2,
    title: "Wheels & Brakes",
  },
  {
    id: "3",
    imgUrls: product3,
    title: "Aviation Tools",
  },
  {
    id: "4",
    imgUrls: product4,
    title: "GGAS Maintenance",
  },
  // {
  //   id: "5",
  //   imgUrls: product5,
  //   title: "Leer Bed Covers",
  //   price: "1449",
  // },
  // {
  //   id: "6",
  //   imgUrls: product6,
  //   title: "White Bed Covers",
  //   price: "1449",
  // },
  // {
  //   id: "7",
  //   imgUrls: product7,
  //   title: "Hand Embroidery Table Cover Set",
  //   price: "1099",
  // },
  // {
  //   id: "8",
  //   imgUrls: product8,
  //   title: "Hand Embroidered Table Covers",
  //   price: "1099",
  // },
];

function FeaturedProducts() {
  const [data, setData] = useState();
  const [error, seterror] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const baseUrl = base_url();
  const getdata = async (page) => {
    setisLoading(true);
    try {
      // const res = await axios.get(`https://onlineparttimejobs.in/api/product/page/${page}&${12}`, { withCredentials: true })
      const res = await axios.get(`${baseUrl}product/page/0&10000`, {
        withCredentials: true,
      });
      setData(res.data);
      setisLoading(false);
    } catch (error) {
      console.log("Server Error !");
      seterror(true);
      setisLoading(false);
    }
  };
  useEffect(() => {
    getdata(0);
  }, []);

  const [modelDataId, setModelDataId] = useState(null);
  const setProduct_id = (id) => {
    setModelDataId(id);
  };

  const [show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setModelDataId(id);
    setShow(true);
  };

  const sortedData = useMemo(() => {
    return data?.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB - dateA;
    });
  }, [data]);

  return (
    <>
      <section className="productsSection sectionPD bgGray">
        <div className="container">
          <div className="row featuredRow d-none">
            <div className="col-lg-12">
              <div className="fishermanHeader ">
                <div className="fisherman-content">
                  <h3>{t("Trending Products")}</h3>
                </div>
              </div>
            </div>
            <FeaturedProduct
              data={sortedData}
              getFeaturedPro={getdata}
              isLoading={isLoading}
              error={error}
              handleShow={handleShow}
              setProduct_id={setProduct_id}
            />
          </div>

          <div className="row featuredRow">
            <div className="col-lg-12">
              <div className="fishermanHeader ">
                <div className="fisherman-content">
                  <h3>{t("Trending Products")}</h3>
                </div>
              </div>
            </div>

            {/* <FeaturedProduct
              data={sortedData}
              getFeaturedPro={getdata}
              isLoading={isLoading}
              error={error}
              handleShow={handleShow}
              setProduct_id={setProduct_id}
            /> */}

            <div className="serviceItemInfo">
              <div className="row">
                {featuredItems.map((item) => {
                  return (
                    <div className="col-lg-3 col-md-6 col-sm-6" key={item.id}>
                      <div className="serviceItem">
                        <div className="serviceItemImg">
                          <img
                            src={item.imgUrls}
                            className="img-fluid"
                            alt={item.title}
                            title={item.title}
                          />
                          <div className="buyNowInfo d-none">
                            <Link className="btn buyNow cart" to="/">
                              Add to Cart{" "}
                              <i className="ri-arrow-right-up-fill" />
                            </Link>
                            <Link className="btn buyNow" to="/">
                              Buy Now
                            </Link>
                          </div>
                        </div>
                        <div className="serviceItemText1">
                          <div className="rating">
                            <AiFillStar />
                            <AiFillStar />
                            <AiFillStar />
                            <AiFillStar />
                            <AiFillStar />
                          </div>

                          <h5>
                            <Link to="/products">
                              {item.title}{" "}
                              <i className="ri-arrow-right-up-fill"></i>
                            </Link>
                          </h5>
                          {/* <p>₹{item.price}.00</p> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <button type="button" className="btn btn-info">
                    {t("Load More")} <BsArrowRight />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* {modelDataId && (
          <QuiekViewModal modelDataId={modelDataId} show={show} onHide={handleClose} size="xl"
            centered />
        )} */}
      </section>
    </>
  );
}

export default FeaturedProducts;
